import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

type Tone = 'blue' | 'red' | 'amber' | 'neutral' | 'green';

const TONES: Record<Tone, { bg: string; fg: string }> = {
  blue: { bg: colors.blue10, fg: colors.blue100 },
  red: { bg: colors.red10, fg: colors.red100 },
  amber: { bg: colors.yellow10, fg: colors.yellow100 },
  neutral: { bg: colors.black5, fg: colors.black75 },
  green: { bg: colors.green10, fg: colors.green100 },
};

export const Chip = styled.span<{ $tone?: Tone }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  background: ${({ $tone = 'neutral' }) => TONES[$tone].bg};
  color: ${({ $tone = 'neutral' }) => TONES[$tone].fg};
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.blue100};
  cursor: pointer;

  &:disabled {
    color: ${colors.black25};
    cursor: default;
  }
`;

export const Muted = styled.span`
  font-size: 12px;
  color: ${colors.black50};
`;

export const Mono = styled.span`
  font-family: monospace;
  font-size: 13px;
  overflow-wrap: anywhere;
`;

export const Struck = styled.span`
  text-decoration: line-through;
  color: ${colors.black50};
`;
